import request from '@/utils/request'

export default {
  index(data, errorback) {
    return request._get('shop/setting.pageelement/index', data, errorback)
  },
  suggestKey(data, errorback) {
    return request._get('shop/setting.pageelement/suggestKey', data, errorback)
  },
  add(data, errorback) {
    return request._post('shop/setting.pageelement/add', data, errorback)
  },
  edit(data, errorback) {
    return request._post('shop/setting.pageelement/edit', data, errorback)
  },
  delete(data, errorback) {
    return request._post('shop/setting.pageelement/delete', data, errorback)
  },
  restore(data, errorback) {
    return request._post('shop/setting.pageelement/restore', data, errorback)
  },
}



// WEBPACK FOOTER //
// ./src/api/pageelement.js